import React from 'react';
import { motion } from 'framer-motion';
interface FooterProps {
  onNavigate: (page: 'terms' | 'privacy') => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  return <footer className="w-full bg-dark-section border-t border-white/5 py-10" data-id="element-126">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-127">
        {/* Disclaimer */}
        <p className="font-inter text-xs text-concrete/50 max-w-2xl mx-auto leading-relaxed mb-6" data-id="element-128">
          This product is for informational and educational purposes only.
          Results may vary based on individual skill level, home construction
          type, and local building codes. Always verify compliance with
          applicable laws in your jurisdiction.
        </p>

        {/* Divider */}
        <div className="w-16 h-px bg-white/10 mx-auto mb-6" data-id="element-129" />

        {/* Links + Copyright */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8" data-id="element-130">
          <span className="font-inter text-xs text-concrete/40" data-id="element-131">
            © {new Date().getFullYear()} Concrete Bunker Blueprint. All rights
            reserved.
          </span>
          <div className="flex items-center gap-6" data-id="element-132">
            <button onClick={() => onNavigate('terms')} className="font-inter text-xs text-concrete/50 hover:text-orange-accent transition-colors duration-200 underline underline-offset-2" data-id="element-133">
              Terms of Service
            </button>
            <button onClick={() => onNavigate('privacy')} className="font-inter text-xs text-concrete/50 hover:text-orange-accent transition-colors duration-200 underline underline-offset-2" data-id="element-134">
              Privacy Policy
            </button>
          </div>
        </div>
      </div>
    </footer>;
}